import React from "react";
import { useSelectTheme } from "../../store";

/** a styled legend */
export const Legend = (props) => {
  const { pad, fontWeight, fontSize } = useSelectTheme();
  return (
    <legend
      css={{
        display: "block",
        fontWeight: fontWeight.bold,
        fontSize: fontSize.h3,
        marginBottom: pad.medium,
      }}
      {...props}
    />
  );
};
